import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import * as customPropTypes from './prop-types'

import styles from './period.module.css'

const propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), customPropTypes.dateRange]).isRequired
}

const defaultProps = {
    onClick: () => {},
    selected: false
}

/**
 * A period component used to provide as list item in the predefined periods
 * list on the right of the DatePickerPopover. Will be rendered in the
 * <PeriodList>.
 */
function DatePickerPeriod({ className, onClick, selected, title, value }) {
    if (value.start && value.start.getTime() > value.end.getTime()) {
        console.error(`DatePicker Period: Start date is supposed to be before end date: ${value.start}/${value.end}`)
    }
    const periodClassName = cx(styles['option'], className, {
        [styles['selected']]: selected,
        't3sel-datepicker-period-selected': selected
    })

    return (
        <li className={periodClassName} onClick={onClick}>
            {title}
        </li>
    )
}

DatePickerPeriod.propTypes = propTypes
DatePickerPeriod.defaultProps = defaultProps

export { DatePickerPeriod }
